import {connect} from 'react-redux'

import {addTravelers} from '../planner/planner.action'
import {TeamBlock} from './teamblock.component'

const mapStateToProps = (state) => ({
    travelers: state.getIn(['document', 'travelers']),
    tripGuid: state.getIn(['document', 'properties', 'tripGuid']),
    activeUsers: state.getIn(['socket', 'presence']),
    isLunaTrip: state.getIn(['lunaTrip', 'isLunaTrip'])
})

const mapDispatchToProps = (dispatch) => ({
    onAddTravelers: (travelers) => {
        dispatch(addTravelers(travelers))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(TeamBlock)
